import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsFinanceByWorkCategories(options = {}) {
  return _apiRequestWrap(
    ModulesMap.REPORTS_FINANCE_BY_WORK_CATEGORIES,
    ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_WORK_CATEGORIES].GET_REPORTS_FINANCE_BY_WORK_CATEGORIES,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_WORK_CATEGORIES].GET_REPORTS_FINANCE_BY_WORK_CATEGORIES]: _getReportsFinanceByWorkCategories,
}